export function kebabToCamelCase(input: string) {
  return input.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
}

export function kebabToTitleCase(input: string) {
  return input.split('-').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
